import { render } from "./InputBox.vue?vue&type=template&id=ad1db36a&scoped=true"
import script from "./InputBox.vue?vue&type=script&lang=js"
export * from "./InputBox.vue?vue&type=script&lang=js"

import "./InputBox.vue?vue&type=style&index=0&id=ad1db36a&scoped=true&lang=css"

import exportComponent from "D:\\newProjectGit\\HbzsbAdminClient\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ad1db36a"]])

export default __exports__